import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 20px;
  background-color: #f5f5f5;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 450px;
  width: 100%;
  padding: 32px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

export const Title = styled.h1`
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 16px;
  color: #333;
  text-align: center
`;

export const Description = styled.p`
  font-size: 1rem;
  margin-bottom: 24px;
  text-align: center;
  color: #666;
`;

export const FormField = styled.div`
  width: 100%;
  margin-bottom: 20px;
  justify-content: center;
  display: flex;
`;

export const ErrorMessage = styled.div`
  width: 100%;
  padding: 12px;
  margin-bottom: 16px;
  background-color: #ffebee;
  color: #d32f2f;
  border-radius: 4px;
  font-size: 0.9rem;
`;

export const SuccessMessage = styled.div`
  width: 100%;
  padding: 12px;
  margin-bottom: 16px;
  background-color: #e8f5e9;
  color: #2e7d32;
  border-radius: 4px;
  font-size: 0.9rem;
`;

export const SubmitButton = styled.button`
  width: 100%;
  padding: 12px;
  background-color: #3f51b5;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #303f9f;
  }

  &:disabled {
    background-color: #bdbdbd;
    cursor: not-allowed;
  }
`;
